import { z } from "zod";

// App user roster for App-Only clients (see the "All App Users" export:
// email, team, status, version). A snapshot of who's registered and in what
// state -- not an activity signal. Deliberately excludes "last signed in":
// a mobile session persists indefinitely, so login recency doesn't indicate
// whether the person has actually used the app since. Actual usage is read
// from check-in/emergency/team-alert data, not this roster.

export const AppUserTeamEntrySchema = z.object({
  team: z.string(),
  total: z.number(),
  active: z.number(),
  invited: z.number(),
  expired: z.number(),
});

export type AppUserTeamEntry = z.infer<typeof AppUserTeamEntrySchema>;

export const AppUserVersionEntrySchema = z.object({
  version: z.string(),
  users: z.number(),
});

export type AppUserVersionEntry = z.infer<typeof AppUserVersionEntrySchema>;

export const AppUserDataSchema = z.object({
  total_users: z.number(),
  active_users: z.number(),
  invited_users: z.number(),
  expired_users: z.number(),
  adoption_rate: z.number().nullable(),
  by_team: z.array(AppUserTeamEntrySchema),
  by_version: z.array(AppUserVersionEntrySchema),
  uploaded_at: z.string().nullable(),
});

export type AppUserData = z.infer<typeof AppUserDataSchema>;
